export default __webpack_public_path__ + "static/media/rig-img.58000de9.png";